module.exports = __webpack_public_path__ + "img/ico_fig.513aaaca.svg";